
import React, { useEffect, useState } from 'react'
import Quickteller from '../../asset/QuicktellerNew.png';
import Stanbic from '../../asset/StanbicLogoNew.png';
import ProductDive from '../../asset/ProductDiveNew.png';
import DescriptionImg from '../../asset/landing_images/descriptionCard.webp';
import Msl from '../../asset/MslLogoNew.png';
import { Link } from 'react-router-dom';


const LandingPartners = () => {
    const [selectedPartnerIndex, setSelectedPartnerIndex] = useState(0);
    const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    setIsReady(true);
  }, []);

     // Handler to update the selected product
     const handleSelectPartner = (index) => {
        setSelectedPartnerIndex(index);
    };

    const partnerContainer = {
        width:'100%',
        minHeight:'100vh',
        marginBottom:'8rem',
        // border:'2px solid green'
    };
    const partnerTitle = {
        fontWeight:700,
        color:'#08839B',
        textAlign:'center'
    };
    const partnerContent = {
        display: "flex",
        justifyContent: "center",
        // alignItems: "center",
        // border:'2px solid red',
        flexDirection: window.innerWidth <= 900?'column': 'row',
        padding:window.innerWidth <= 760 ? '2rem 1.5rem'
            :window.innerWidth <= 900 ? '2rem 3rem' : '2rem 5.5rem',
        gap: window.innerWidth <= 900? '2rem':'12rem',
    };
    const partnerList = {
        // width:window.innerWidth <= 1200? '10%':'30%',
        display:window.innerWidth <= 900?'flex':'block',
        // border:'2px solid blue',
        flexWrap:'wrap',
    };
   
    const partnerBox = (isActive) => ({
        // border:'2px solid green',
        padding:window.innerWidth <= 900 ? '0.5rem' : '1.5rem ',
        display:'flex',
        justifyContent: 'center',
        alignItem:'center',
        borderRadius: '0.60713rem',
        backgroundColor: isActive ? "#CCF0F6" : "#F5F5F5",
        opacity: isActive ? "1" :'0.5',
        cursor:'pointer',
        marginBottom:'2rem',
        marginRight: window.innerWidth <= 1200?'1rem':0,
        transition: "all 0.3s ease-in-out",
    });

    const partnerImg = {
        width:window.innerWidth <= 1200?'5rem':"",
        objectFit: 'contain'
    };

    const partnerDescription = {
        position: "relative", // Helps with stacking
        padding: "2rem",
        width:'100%',
        display:'flex',
        alignItems: window.innerWidth <= 1200 ? "":'center',
      };
      
      const descriptionBox = {
        position: "absolute",
        transition: "transform 0.3s ease-in-out",
        cursor: "pointer",
        // zIndex: index === selectedPartnerIndex ? 10 : index,
      };

      const descripImg = {
        position:'relative',
        width:'100%',
        height:window.innerWidth <= 760?'50vh':'auto'
      };

      const descripTitle = {
        color:'#08839B', 
        fontSize:window.innerWidth <= 760?'1.5rem':'2rem', 
        fontWeight:500 , 
        marginBottom:window.innerWidth <= 760 ? '1rem' : '1.5rem'
      }
     const descripBody = {
        fontSize:window.innerWidth <= 760 ?'0.8rem':
        window.innerWidth <= 1200 ? '1.3rem':
        '1.1rem', 
        fontWeight:400
     }

      const textInCard = {
        position: "absolute",
        bottom:window.innerWidth <= 760 ? "3rem": window.innerWidth <= 1200 ? '8rem' : "4rem",
        left: 0,
        width: "100%",
        padding:window.innerWidth <= 760 ?"0 2rem":  "0 4rem",
        fontSize: "14px",
        opacity: 1, // Change to 0 if you want it hidden by default
        transition: "opacity 0.3s ease-in-out",
      }
      const buttonContainer = {
        position: "relative",
        display: "inline-block",
        padding: "2px", // Creates space for the gradient border
        borderRadius: "0.5rem",
        background:" linear-gradient(210deg, #08FFB8 13.4%, #5799F7 86.6%)" // Gradient border
      };
      
      const buttonStyle = {
        // display: "block",
        width: "150px",
        height: "50px",
        border: "none",
        display: "flex",
        justifyContent:"center",
        alignItems:"center",
        textDecoration: "none",
        borderRadius:'0.5rem',
        background: "#fff",
        color: "#4E99DD",
        fontSize: "1.3rem",
        fontWeight: 400,
        cursor: "pointer",
        transition: "transform 0.2s ease-in-out",
      }

    const partners = [
        {
            name:"Quickteller",
            url: "/transport",
            img: Quickteller,
            description: "A QUICK CREDIT/LENDING transport ticket to Orientation Camps, customized travel, including insurance and more, courtesy of Quickteller"
        },
        {
            name:"Stanbic IBTC",
            url: "/complete-stanbicibtc-registration",
            img: Stanbic,
            description: "Open a Stanbic IBTC account through YouthPlus and enjoy exclusive perks, giveaways, and special promotions. Experience banking with rewards designed just for you!"
        },{
            name:"Product Dive",
            url:"https://productdive.com/productmanagementlaunchpad/",
            img: ProductDive,
            description: "ProductDive’s Product Management Launchpad equips NYSC members with essential skills for a successful career. Tailored to all service stages, it complements your academic background seamlessly."
        },{
            name: "MSL",
            url: "https://app.myshoplauncher.com/register?slug=VYnnj6TYRX_monthly&role=merchant",
            img: Msl,
            description: "Entrepreneurs and freelancers, launch your online store effortlessly with MyshopLauncher! Design, manage, and grow your e-commerce business anytime, anywhere. Start selling with ease today!"
        },
    ]

  return (
    <div style={partnerContainer} id='partners'>
      <div>
        <h1 style={partnerTitle}>Our Partners</h1>
        <div style={partnerContent}>
            <div style={partnerList}>
               {partners.map((partner,index)=>(
                <div key={partner.name+index} style={partnerBox(index === selectedPartnerIndex)}
                onClick={() => handleSelectPartner(index)}>
                    <img src={partner.img} alt='partner' style={partnerImg}/>
                </div>
               ))

               } 
            </div>
            {isReady &&
              <div style={partnerDescription}>
              {partners.map((partner, index)=>(
                  <div key={partner.name + index}
                  style={{
                      ...descriptionBox,
                      marginTop: index * -10, // Adjust negative margin to overlap
                      zIndex:index === selectedPartnerIndex ? 10 : partners.length - index, // Ensure correct stacking order
                      // transform: index === selectedPartnerIndex ? "scale(1)" : "scale(0.9)",
                    }}
                  >
                      <img src={DescriptionImg} alt='description-card' style={descripImg}/>
                      <div style={textInCard}>
                          <h3 
                          style={descripTitle }>
                                  {partner.name}
                          </h3>
                          <p style={descripBody}>{partner.description}
                          </p>
                          <div style={buttonContainer}>
                          <Link to={partner.url} target='blank' style={buttonStyle}>Visit</Link>
                          </div>
                      </div>
                  </div>
                ))
              }
              </div>
            }
        </div>
      </div>
    </div>
  )
}

export default LandingPartners
